import { useState, useEffect } from 'react';
import apiService from '../services/apiService';

const useInvestments = (currentPage = 1, currentPageLimit = 100, refreshKey) => {
  const [investments, setInvestments] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInvestments = async () => {
      setLoading(true);
      try {
        const response = await apiService.getInvestments(currentPage, currentPageLimit);
        const data = response?.data || response;
        const { items = [], total_pages = 1, total_items = 0 } = data;
        setInvestments(items || []);
        setTotalPages(total_pages || 1);
        setTotalItems(total_items || 0);
        setError(null);
      } catch (err) {
        console.error(err);
        setError(err.message || 'Error fetching investments');
      } finally {
        setLoading(false);
      }
    };
    fetchInvestments();
  }, [currentPage, currentPageLimit, refreshKey]);

  return { investments, totalPages, totalItems, loading, error };
};

export default useInvestments;
